<template>
  <svg
    width="176"
    height="208"
    viewBox="0 0 176 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9766_16822)">
      <path
        opacity="0.08"
        d="M163.19 113.61C179.52 123.04 179.51 138.32 163.19 147.74C146.86 157.17 120.4 157.17 104.07 147.74C87.7399 138.31 87.7499 123.03 104.07 113.61C120.4 104.18 146.86 104.18 163.19 113.61Z"
        fill="black"
      />
      <path
        opacity="0.08"
        d="M96.7 152.16C118.82 164.93 118.82 185.64 96.7 198.41C74.58 211.18 38.71 211.18 16.59 198.41C-5.53 185.64 -5.53 164.93 16.59 152.16C38.71 139.39 74.58 139.39 96.7 152.16Z"
        fill="black"
      />
      <path
        d="M94.45 134.66C115.32 146.71 115.32 166.25 94.45 178.3C73.58 190.35 39.73 190.35 18.86 178.3C-2.00998 166.25 -2.00998 146.71 18.86 134.66C39.73 122.61 73.58 122.61 94.45 134.66Z"
        fill="#F28435"
      />
      <path
        d="M173.53 126.7V116.11H168.05C166.37 114.47 164.31 112.92 161.87 111.51C146.27 102.5 120.98 102.5 105.37 111.51C102.93 112.92 100.87 114.47 99.19 116.11H93.68V127.82C93.67 133.72 97.57 139.63 105.37 144.13C120.97 153.14 146.26 153.14 161.87 144.13C170.17 139.34 174.05 132.97 173.52 126.7H173.53Z"
        fill="#8A3CA6"
      />
      <path
        d="M161.87 99.79C177.47 108.8 177.47 123.4 161.87 132.41C146.27 141.42 120.98 141.42 105.37 132.41C89.7699 123.4 89.7699 108.8 105.37 99.79C120.97 90.78 146.26 90.78 161.87 99.79Z"
        fill="#5E1677"
      />
      <path
        d="M168.18 113.99V113.79C168.14 113.15 168.05 112.52 167.91 111.88C167.91 111.88 160.45 92.31 160.45 55.69H106.84C106.84 92.91 99.6698 110.8 99.6698 110.8C97.6498 117.05 100.82 123.76 109.2 128.6C122.7 136.39 144.59 136.39 158.09 128.6C165.06 124.58 168.42 119.26 168.19 113.99H168.18Z"
        fill="#B7B1C2"
      />
      <path
        d="M161.42 53.45V50.5H105.8V54.23C105.8 58.34 108.51 62.45 113.94 65.59C124.81 71.87 142.43 71.86 153.3 65.59C159.08 62.25 161.79 57.81 161.42 53.44V53.45Z"
        fill="#8A3CA6"
      />
      <path
        d="M153.31 39.14C164.18 45.42 164.18 55.59 153.31 61.86C142.44 68.14 124.82 68.14 113.95 61.86C103.08 55.58 103.08 45.41 113.95 39.14C124.82 32.86 142.44 32.86 153.31 39.14Z"
        fill="#5E1677"
      />
      <path
        d="M133.62 63.67C126.73 63.67 120.08 61.91 115.36 58.83C111.57 56.36 109.4 53.33 109.4 50.5C109.4 47.67 111.57 44.64 115.36 42.17C120.08 39.09 126.74 37.33 133.63 37.33C140.52 37.33 147.17 39.09 151.89 42.17C155.68 44.64 157.85 47.67 157.85 50.5C157.85 53.33 155.68 56.36 151.89 58.83C147.17 61.91 140.51 63.67 133.62 63.67Z"
        fill="#3B3B3B"
      />
      <path
        d="M148.181 42.4669C150.556 32.4898 144.393 22.4763 134.416 20.1013C124.439 17.7262 114.425 23.8889 112.05 33.8661C109.675 43.8432 115.838 53.8566 125.815 56.2317C135.792 58.6067 145.806 52.444 148.181 42.4669Z"
        fill="#6B7176"
      />
      <path
        d="M154.501 44.2919C160.445 38.3481 160.445 28.7114 154.501 22.7676C148.557 16.8238 138.921 16.8238 132.977 22.7676C127.033 28.7114 127.033 38.3481 132.977 44.2919C138.921 50.2357 148.557 50.2357 154.501 44.2919Z"
        fill="#6B7176"
      />
      <path
        d="M151.626 20.9165C153.228 14.1729 149.059 7.40784 142.316 5.80627C135.572 4.20469 128.807 8.37312 127.205 15.1167C125.604 21.8603 129.772 28.6254 136.516 30.227C143.259 31.8286 150.024 27.6601 151.626 20.9165Z"
        fill="#6B7176"
      />
      <path
        d="M148.47 16.8C153.109 16.8 156.87 13.0392 156.87 8.4C156.87 3.76081 153.109 0 148.47 0C143.831 0 140.07 3.76081 140.07 8.4C140.07 13.0392 143.831 16.8 148.47 16.8Z"
        fill="#6B7176"
      />
      <path
        d="M168.29 10.27C168.29 12.35 166.61 14.03 164.53 14.03C162.45 14.03 160.77 12.35 160.77 10.27C160.77 8.19001 162.45 6.51001 164.53 6.51001C166.61 6.51001 168.29 8.19001 168.29 10.27Z"
        fill="#6B7176"
      />
      <path
        d="M110.04 170.67V156.5H102.71C100.47 154.3 97.7099 152.24 94.4499 150.35C73.5799 138.3 39.7299 138.3 18.8599 150.35C15.5899 152.24 12.8399 154.3 10.5999 156.5H3.20994L3.18994 172.17C3.18994 180.07 8.40994 187.97 18.8499 193.99C39.7199 206.04 73.5699 206.04 94.4399 193.99C105.54 187.58 110.74 179.05 110.03 170.66L110.04 170.67Z"
        fill="#F4884D"
      />
      <path
        d="M94.45 134.66C115.32 146.71 115.32 166.25 94.45 178.3C73.58 190.35 39.73 190.35 18.86 178.3C-2.00998 166.25 -2.00998 146.71 18.86 134.66C39.73 122.61 73.58 122.61 94.45 134.66Z"
        fill="#F28435"
      />
      <path
        d="M102.88 153.66L102.87 153.39C102.82 152.54 102.7 151.68 102.5 150.84C102.5 150.84 92.5098 124.66 92.5098 75.66H20.7798C20.7798 125.47 11.1898 149.4 11.1898 149.4C8.47983 157.77 12.7298 166.74 23.9398 173.21C41.9998 183.64 71.2898 183.64 89.3498 173.21C98.6698 167.83 103.17 160.72 102.87 153.66H102.88Z"
        fill="#DFDFDF"
      />
      <path
        d="M93.8399 72.66V68.71H19.4199V73.71C19.4099 79.21 23.0399 84.72 30.3099 88.91C44.8499 97.31 68.4299 97.31 82.9799 88.91C90.7099 84.44 94.3299 78.5 93.8399 72.66Z"
        fill="#F28435"
      />
      <path
        d="M82.98 53.51C97.52 61.91 97.52 75.52 82.98 83.92C68.44 92.32 44.86 92.32 30.31 83.92C15.77 75.52 15.77 61.91 30.31 53.51C44.85 45.11 68.43 45.11 82.98 53.51Z"
        fill="#FC9F6B"
      />
      <path
        d="M56.64 86.33C47.43 86.33 38.52 83.97 32.2 79.85C27.13 76.55 24.23 72.49 24.23 68.71C24.23 64.93 27.14 60.87 32.2 57.57C38.52 53.45 47.43 51.09 56.64 51.09C65.85 51.09 74.76 53.45 81.08 57.57C86.15 60.87 89.05 64.93 89.05 68.71C89.05 72.49 86.14 76.55 81.08 79.85C74.76 83.97 65.85 86.33 56.64 86.33Z"
        fill="#3B3B3B"
      />
      <path
        d="M51.0299 143.71C49.9399 154.12 42.1799 158.34 33.7099 153.14C25.2399 147.93 19.2599 135.27 20.3499 124.86C21.4399 114.45 29.1999 110.23 37.6699 115.43C46.1399 120.64 52.1199 133.3 51.0299 143.71Z"
        fill="#F28435"
      />
      <path
        d="M43.7998 124.19L38.0498 131.35C39.1098 132.9 39.7498 134.92 39.5598 136.68C39.5598 136.73 39.5598 136.77 39.5498 136.82L48.9398 142.59C48.9398 142.59 48.9398 142.5 48.9498 142.45C49.5798 136.41 47.4698 129.47 43.7998 124.2V124.19ZM30.3598 116.02C26.1398 116.47 22.9398 120.07 22.3098 126.06L31.7398 131.86C31.9198 130.12 32.8398 129.1 34.0398 128.93L30.3598 116.03V116.02ZM33.2098 137.16L27.4598 144.27C29.2798 146.89 31.4598 149.13 33.8998 150.63C36.2898 152.1 38.6098 152.68 40.6898 152.51L37.0498 139.58C36.4498 139.61 35.7998 139.46 35.1198 139.04C34.3898 138.59 33.7398 137.94 33.1998 137.16H33.2098Z"
        fill="#3B3B3B"
      />
      <path
        d="M37.9698 135.51C37.7898 137.2 36.5398 137.88 35.1698 137.03C33.7998 136.19 32.8298 134.14 33.0098 132.45C33.1898 130.76 34.4398 130.08 35.8098 130.92C37.1798 131.76 38.1498 133.81 37.9698 135.5V135.51Z"
        fill="#3B3B3B"
      />
      <path
        d="M61.602 75.1067C74.2433 69.7772 80.1706 55.2091 74.8412 42.5678C69.5117 29.9266 54.9436 23.9992 42.3023 29.3287C29.6611 34.6582 23.7337 49.2263 29.0632 61.8676C34.3927 74.5088 48.9608 80.4362 61.602 75.1067Z"
        fill="#6B7176"
      />
      <path
        d="M84.5853 60.4059C92.5403 52.451 92.5403 39.5534 84.5853 31.5984C76.6303 23.6434 63.7328 23.6434 55.7778 31.5984C47.8228 39.5534 47.8228 52.451 55.7778 60.4059C63.7328 68.3609 76.6303 68.3609 84.5853 60.4059Z"
        fill="#6B7176"
      />
      <path
        d="M72.7796 39.7964C80.815 35.1572 83.5681 24.8825 78.9289 16.8472C74.2897 8.81184 64.015 6.05874 55.9796 10.6979C47.9443 15.3371 45.1912 25.6118 49.8304 33.6472C54.4696 41.6825 64.7443 44.4356 72.7796 39.7964Z"
        fill="#6B7176"
      />
      <path
        d="M84.4625 20.3311C88.852 15.9416 88.852 8.82485 84.4625 4.43536C80.073 0.0458641 72.9563 0.0458634 68.5668 4.43536C64.1773 8.82485 64.1773 15.9416 68.5668 20.3311C72.9563 24.7206 80.073 24.7206 84.4625 20.3311Z"
        fill="#6B7176"
      />
      <path
        d="M103.04 14.88C103.04 17.66 100.79 19.91 98.01 19.91C95.23 19.91 92.98 17.66 92.98 14.88C92.98 12.1 95.23 9.85001 98.01 9.85001C100.79 9.85001 103.04 12.1 103.04 14.88Z"
        fill="#6B7176"
      />
    </g>
    <defs>
      <clipPath id="clip0_9766_16822">
        <rect width="175.43" height="207.99" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
